// extracted by mini-css-extract-plugin
module.exports = {"Flexible":"Flexible_Flexible__emvNB"};